/* global google */
import { Loader } from "@googlemaps/js-api-loader";

const getCenter = (markers) => {
  const count = markers.length;
  let latSum = 0;
  let lngSum = 0;
  markers.forEach((marker) => {
    const { lat, lng } = marker;
    latSum += lat;
    lngSum += lng;
  });
  return { lat: latSum / count, lng: lngSum / count };
};

const initMap = (container, mapData) => {
  const { markers, zoom } = mapData;
  if (!google || !markers || !markers.length) {
    return;
  }
  const map = new google.maps.Map(container, {
    zoom,
    center: getCenter(markers),
    scrollwheel: true,
  });

  let infoWindow = null;
  markers.forEach((marker) => {
    const gMarker = new google.maps.Marker({
      position: marker,
      map,
      title: marker.title,
    });
    gMarker.addListener("click", () => {
      if (marker.info) {
        if (infoWindow) {
          infoWindow.close();
        }
        infoWindow = new google.maps.InfoWindow({
          content: marker.info,
        });
        infoWindow.open(map, gMarker);
      }
    });
  });
};

export const render = (mapContainers) => {
  const loader = new Loader({
    apiKey: mapContainers[0].dataset.apiKey,
    version: "weekly",
  });
  loader.load().then(
    () => {
      mapContainers.forEach((container) => {
        const mapData = JSON.parse(container.dataset.mapData);
        initMap(container, mapData);
      });
    },
    () => {
      mapContainers.forEach((container) => {
        container.innerHTML =
          "<div class='d-flex align-items-center justify-content-center h-100 w-100'>Failed to load Google Map.</div>";
      });
    },
  );
};
